export const RewardDecisionVI = {
    "decisions": {
        "headingLabel": "Quyết định",
        "generalInformation": "Thông tin chung",
        "header": {
            "addDisciplineDecision": "Tạo mới quyết định kỷ luật",
            "updateDisciplineDecision": "Cập nhật quyết định kỷ luật",
            "detailDisciplineDecision": "Chi tiết quyết định kỷ luật",
            "addRewardDecision": "Tạo mới quyết định khen thưởng",
            "updateRewardDecision": "Cập nhật quyết định khen thưởng",
            "detailRewardDecision": "Chi tiết quyết định khen thưởng",
        },
        "placeholder": {
            "no": "QD001",
            "decisionDate": "DD-MM-YYYY",
            "decisionMaker": "Nhập cấp ra quyết định",
            "validityDate": "DD-MM-YYYY",
            "description": "Nhập mô tả",
            "typeReward": "Chọn hình thức khen thưởng",
            "amount": "1,000,000",
            "paymentType": "Chọn kiểu thanh toán",
            "reasonReward": "Nhập lý do",
            "approve": "Chọn người duyệt",
            "employeeReward": "Phòng ban, Vị trí, Chức vụ, Nhân viên, ...",
            "typeDiscipline": "Chọn hình thức"
        },
        "label": {
            "no": "Số quyết định",
            "decisionDate": "Ngày quyết định",
            "decisionMaker": "Cấp ra quyết định",
            "validityDate": "Ngày hiệu lực",
            "description": "Mô tả",
            "type": "Hình thức",
            "amount": "Số tiền",
            "paymentType": "Kiểu thanh toán",
            "reasonReward": "Lý do",
            "approve": "Người duyệt",
            "employeeReward": "Nhân viên khen thưởng",
            "status": "Trạng thái",
            "employeeDiscipline": "Nhân viên"
        },
        "type": {
            "reward": {
                "heading": "Quyết định khen thưởng",
                "paid": "Đã thanh toán",
                "addToSalary": "Cộng vào lương",
                "department": "Phòng ban",
                "position": "Vị trí",
                "employee": "Nhân viên",
                "validate": {
                    "employeeReward": "Chưa nhập nhân viên khen thưởng",
                    "validityDate": "Chưa nhập ngày hiệu lực",
                    "decisionDate": "Chưa nhập ngày quyết định",
                    "decisionNo": "Chưa nhập số quyết định",
                    "decisionMaker": "Chưa nhập cấp ra quyết định",
                    "typeReward": "Chưa nhập hình thức khen thưởng",
                    "amount": "Chưa nhập số tiền",
                    "paymentType": "Chưa nhập hình thức thanh toán"
                }
            },
            "discipline": {
                "heading": "Kỷ luật lao động"
            }
        },
        "rule": {
            "decisionNo" : "Vui lòng nhập số quyết định!",
            "decisionDate": "Vui lòng nhập ngày quyết định!",
            "validityDate": "Vui lòng nhập ngày hiệu lực!",
            "reprimandMethod": "Vui lòng chọn hình thức kỷ luật!",
            "disciplineEmployee": "Vui lòng chọn nhân viên kỷ luật!",
            "rewardMethod": "Vui lòng chọn hình thức khen thưởng!",
            "rewardEmployee": "Vui lòng chọn nhân viên khen thưởng!"
        }
    }
}